import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { IWorkshop } from 'models/workshop';
import { IWorkshopsGroup } from 'models/workshopsgroup';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  workshopsGroup: IWorkshopsGroup;
  workshops: IWorkshop[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditWorkshopsGroup: React.FC<Props> = ({ open, loading, workshopsGroup, workshops,
  onClose, onSubmit, onChanges }) => {


  let workshopOptions = workshops.map((workshop) => {
    return { value: workshop.workshopId, label: workshop.topicName + ' ' + workshop.fromDate.split('T')[0] + ' ' + workshop.trainer };
  });

  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: 'workshops',
      label: t('T_workshops'),
      type: InputTypes.MULTI_SELECT,

      options: workshopOptions,
      multiple: true,
      internalLabel: true,
      required: true,
      defaultValue: workshopOptions.filter((workshop) => workshopsGroup.workshopIds.includes(workshop.value))
    }
  ];




  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_workshop_group')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t("T_cancel")}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t("T_save")}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditWorkshopsGroup;
